import React, { Suspense } from "react";
import LectureHistory from "./LectureHistory";
import TrialExamHistory from "./TrialExamHistory";
import useAxios from "../../../../MainComponents/Hooks/useAxios";
import ResultsGraph from "./ResultsGraph";

const StudentResults = () => {
  const [resultsSuccess, resultsErrors, resultsLoading] = useAxios(
    process.env.REACT_APP_STUDENT_RESULTS_API,
    "GET",
    "GET"
  );

  const lectures = resultsSuccess?.data?.histories || [];
  const trialExams = resultsSuccess?.data?.trial_exams || [];

  if (resultsErrors)
    return (
      <div className="min-h-screen flex flex-col items-center justify-center text-red-500">
        {resultsErrors?.reponse?.data?.message || "something went wrong"}
      </div>
    );

  return (
    <div className="max-w-3/4 w-full mx-auto py-5 ">
      <Suspense>
        <LectureHistory lectures={lectures} loading={resultsLoading} />
      </Suspense>
      <Suspense>
        <TrialExamHistory trialExams={trialExams} loading={resultsLoading} />
      </Suspense>
      <Suspense>
        <ResultsGraph />
      </Suspense>
    </div>
  );
};

export default StudentResults;
